<template>
    <div>
        <div class="page-catalog__top top-catalog-page">
            <properties-page-filter
                v-if="paginator"
                :paginator="paginator"
                :numbering="numbering"
                :total-properties-number="totalPropertiesNumber"
                :property-types="propertyTypes"
            ></properties-page-filter>
        </div>
        <div class="catalog-list">
            <div class="catalog-list__container">
                <div
                    v-if="paginator"
                    class="catalog-list__row"
                    key="paginatorWrapper"
                >
                    <div
                        v-for="property in paginator.data"
                        :key="'propertyCard' + property.id"
                    >
                        <catalog-property-card
                            :property="property"
                            :is-slider="false"
                        ></catalog-property-card>
                    </div>
                </div>
                <div class="catalog-list__footer">
                    <catalog-list-pagination
                        v-if="paginator"
                        :paginator="paginator"
                        @page-changed="changePage"
                    ></catalog-list-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import Swiper, {EffectFade, Navigation, Pagination} from "swiper";

export default {
    name: "CatalogListProperties",
    props: {
        propertyTypes: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters({
            storedFiltersApplied: 'filtration/storedFiltersApplied',
            paginator: 'filtration/paginator',
            numbering: 'filtration/numbering',
            totalPropertiesNumber: 'filtration/totalPropertiesNumber'
        })
    },
    methods: {
        initSwiperImages() {
            this.$nextTick(() => {
                let arrsPrev = document.querySelectorAll(".card-button_prev");
                let arrsNext = document.querySelectorAll(".card-button_next");
                let cardSlider = document.querySelectorAll(".card__slider");

                for (let index = 0; index < cardSlider.length; index++) {
                    const slider = cardSlider[index];
                    new Swiper(slider, {
                        modules: [Pagination, EffectFade, Navigation],
                        observer: true,
                        observeParents: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        speed: 800,
                        watchOverflow: true,
                        effect: "fade",
                        pagination: {
                            el: slider.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        navigation: {
                            prevEl: arrsPrev[index],
                            nextEl: arrsNext[index]
                        },
                        breakpoints: {
                            320: {},
                            768: {
                                touchRatio: 0,
                                navigation: {
                                    prevEl: ".card-button_prev",
                                    nextEl: ".card-button_next"
                                }
                            }
                        },
                    });
                }
            });
        },
        changePage(page) {
            this.$store.dispatch('filtration/changePage', page).then(() => {
                this.initSwiperImages();
                if (window.innerWidth <= 768) {
                    window.scrollTo(0, 0)
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }
            });
        },
    },
    watch: {
        paginator: {
            handler() {
                this.initSwiperImages();
            },
            immediate: true
        }
    },
    mounted() {
        let queryParams = window.localStorage.getItem('filtrationQueryParams')
            if (!!queryParams && queryParams !== 'null') {
                this.$store.dispatch('filtration/updateStoredSelectedFilters', JSON.parse(queryParams));
            } else {
                const urlParams = new URLSearchParams(window.location.search);
                const currentPage = urlParams.get('page') ? parseInt(urlParams.get('page'), 10) : 1;

                this.$store.dispatch('filtration/changePage', currentPage).then(() => {
                    this.initSwiperImages();
                });
            }
    }
}
</script>
